import React from 'react';
import Spinner from '../components/Spinner';

export default function CheckoutLoader() {
  return (
    <div className="cp_loading-container flex col text-center justify-center p-4 h-64">
      <Spinner className="cp_spinner" />
    </div>
  );
}
